export const ApoCharacterData = [
  {
    char: 'acheron',
    name: 'Acheron',
    current_app_rate: 24.77,
    app_eidolons: 17.48,
    app_free: 0.85,
    current_avg_score: 3334,
    round_eidolons: 3449,
    round_free: 3291,
    prev_app_rate: 30.28,
    prev_avg_score: 3325,
    rarity: 'Limited 5*'
  },
  {
    char: 'aglaea',
    name: 'Aglaea',
    current_app_rate: 16.06,
    app_eidolons: 8.72,
    app_free: 2.54,
    current_avg_score: 3474,
    round_eidolons: 3625,
    round_free: 3439,
    prev_app_rate: 2.66,
    prev_avg_score: 3460,
    rarity: 'Limited 5*'
  },
  {
    char: 'argenti',
    name: 'Argenti',
    current_app_rate: 3.17,
    app_eidolons: 1.6,
    app_free: 0.56,
    current_avg_score: 3573,
    round_eidolons: 3602,
    round_free: 3554,
    prev_app_rate: 5.8,
    prev_avg_score: 3401,
    rarity: 'Limited 5*'
  },
  {
    char: 'arlan',
    name: 'Arlan',
    current_app_rate: 0.01,
    app_eidolons: 0,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.01,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'asta',
    name: 'Asta',
    current_app_rate: 0.16,
    app_eidolons: 0.06,
    app_free: 0.05,
    current_avg_score: 3402,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.31,
    prev_avg_score: 3312,
    rarity: '4*'
  },
  {
    char: 'aventurine',
    name: 'Aventurine',
    current_app_rate: 49.24,
    app_eidolons: 24.45,
    app_free: 10.73,
    current_avg_score: 3418,
    round_eidolons: 3494,
    round_free: 3404,
    prev_app_rate: 53.78,
    prev_avg_score: 3454,
    rarity: 'Limited 5*'
  },
  {
    char: 'bailu',
    name: 'Bailu',
    current_app_rate: 0.94,
    app_eidolons: 0.46,
    app_free: 0.16,
    current_avg_score: 3337,
    round_eidolons: 3435,
    round_free: 3316,
    prev_app_rate: 0.63,
    prev_avg_score: 3378,
    rarity: 'Standard 5*'
  },
  {
    char: 'black-swan',
    name: 'Black Swan',
    current_app_rate: 5.16,
    app_eidolons: 3.93,
    app_free: 0.16,
    current_avg_score: 3224,
    round_eidolons: 3357,
    round_free: 3186,
    prev_app_rate: 12.26,
    prev_avg_score: 3293,
    rarity: 'Limited 5*'
  },
  {
    char: 'blade',
    name: 'Blade',
    current_app_rate: 1.77,
    app_eidolons: 1.21,
    app_free: 0.21,
    current_avg_score: 3365,
    round_eidolons: 3424,
    round_free: 3339,
    prev_app_rate: 0.49,
    prev_avg_score: 3276,
    rarity: 'Limited 5*'
  },
  {
    char: 'boothill',
    name: 'Boothill',
    current_app_rate: 6.23,
    app_eidolons: 2.81,
    app_free: 1.01,
    current_avg_score: 3483,
    round_eidolons: 3584,
    round_free: 3429,
    prev_app_rate: 1.33,
    prev_avg_score: 3220,
    rarity: 'Limited 5*'
  },
  {
    char: 'bronya',
    name: 'Bronya',
    current_app_rate: 10.23,
    app_eidolons: 6.39,
    app_free: 1.43,
    current_avg_score: 3531,
    round_eidolons: 3624,
    round_free: 3497,
    prev_app_rate: 4.37,
    prev_avg_score: 3394,
    rarity: 'Standard 5*'
  },
  {
    char: 'clara',
    name: 'Clara',
    current_app_rate: 0.51,
    app_eidolons: 0.34,
    app_free: 0.05,
    current_avg_score: 3213,
    round_eidolons: 3323,
    round_free: 0,
    prev_app_rate: 1.46,
    prev_avg_score: 3143,
    rarity: 'Standard 5*'
  },
  {
    char: 'dan-heng',
    name: 'Dan Heng',
    current_app_rate: 0.08,
    app_eidolons: 0.05,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.01,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'dr-ratio',
    name: 'Dr. Ratio',
    current_app_rate: 0.28,
    app_eidolons: 0.16,
    app_free: 0.03,
    current_avg_score: 3100,
    round_eidolons: 3302,
    round_free: 0,
    prev_app_rate: 0.51,
    prev_avg_score: 3230,
    rarity: 'Limited 5*'
  },
  {
    char: 'feixiao',
    name: 'Feixiao',
    current_app_rate: 37.01,
    app_eidolons: 16.32,
    app_free: 11.72,
    current_avg_score: 3439,
    round_eidolons: 3567,
    round_free: 3409,
    prev_app_rate: 16.7,
    prev_avg_score: 3488,
    rarity: 'Limited 5*'
  },
  {
    char: 'firefly',
    name: 'Firefly',
    current_app_rate: 15.56,
    app_eidolons: 13.09,
    app_free: 1.12,
    current_avg_score: 3248,
    round_eidolons: 3423,
    round_free: 3249,
    prev_app_rate: 42.18,
    prev_avg_score: 3353,
    rarity: 'Limited 5*'
  },
  {
    char: 'fu-xuan',
    name: 'Fu Xuan',
    current_app_rate: 16.83,
    app_eidolons: 10.4,
    app_free: 2.3,
    current_avg_score: 3386,
    round_eidolons: 3440,
    round_free: 3390,
    prev_app_rate: 23.32,
    prev_avg_score: 3406,
    rarity: 'Limited 5*'
  },
  {
    char: 'gallagher',
    name: 'Gallagher',
    current_app_rate: 24.39,
    app_eidolons: 10.76,
    app_free: 6.13,
    current_avg_score: 3394,
    round_eidolons: 3429,
    round_free: 3389,
    prev_app_rate: 35.94,
    prev_avg_score: 3373,
    rarity: '4*'
  },
  {
    char: 'gepard',
    name: 'Gepard',
    current_app_rate: 0.89,
    app_eidolons: 0.57,
    app_free: 0.11,
    current_avg_score: 3356,
    round_eidolons: 3337,
    round_free: 3346,
    prev_app_rate: 1.04,
    prev_avg_score: 3298,
    rarity: 'Standard 5*'
  },
  {
    char: 'guinaifen',
    name: 'Guinaifen',
    current_app_rate: 0.33,
    app_eidolons: 0.15,
    app_free: 0.05,
    current_avg_score: 3284,
    round_eidolons: 3358,
    round_free: 0,
    prev_app_rate: 0.37,
    prev_avg_score: 3202,
    rarity: '4*'
  },
  {
    char: 'hanya',
    name: 'Hanya',
    current_app_rate: 0.11,
    app_eidolons: 0.04,
    app_free: 0.05,
    current_avg_score: 3388,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.09,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'herta',
    name: 'Herta',
    current_app_rate: 28.12,
    app_eidolons: 10.59,
    app_free: 8.03,
    current_avg_score: 3484,
    round_eidolons: 3578,
    round_free: 3464,
    prev_app_rate: 36.7,
    prev_avg_score: 3463,
    rarity: '4*'
  },
  {
    char: 'himeko',
    name: 'Himeko',
    current_app_rate: 1.25,
    app_eidolons: 0.62,
    app_free: 0.31,
    current_avg_score: 3420,
    round_eidolons: 3554,
    round_free: 3427,
    prev_app_rate: 1.26,
    prev_avg_score: 3329,
    rarity: 'Standard 5*'
  },
  {
    char: 'hook',
    name: 'Hook',
    current_app_rate: 0.02,
    app_eidolons: 0.02,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.02,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'huohuo',
    name: 'Huohuo',
    current_app_rate: 26.65,
    app_eidolons: 13.36,
    app_free: 5.54,
    current_avg_score: 3432,
    round_eidolons: 3506,
    round_free: 3414,
    prev_app_rate: 22.27,
    prev_avg_score: 3438,
    rarity: 'Limited 5*'
  },
  {
    char: 'imbibitor-lunae',
    name: 'Imbibitor Lunae',
    current_app_rate: 0.84,
    app_eidolons: 0.82,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 3301,
    round_free: 0,
    prev_app_rate: 3.97,
    prev_avg_score: 3255,
    rarity: 'Limited 5*'
  },
  {
    char: 'jade',
    name: 'Jade',
    current_app_rate: 20.77,
    app_eidolons: 10.42,
    app_free: 4.27,
    current_avg_score: 3596,
    round_eidolons: 3670,
    round_free: 3582,
    prev_app_rate: 23.99,
    prev_avg_score: 3534,
    rarity: 'Limited 5*'
  },
  {
    char: 'jiaoqiu',
    name: 'Jiaoqiu',
    current_app_rate: 14.44,
    app_eidolons: 9.68,
    app_free: 0.55,
    current_avg_score: 3380,
    round_eidolons: 3497,
    round_free: 3334,
    prev_app_rate: 18.61,
    prev_avg_score: 3347,
    rarity: 'Limited 5*'
  },
  {
    char: 'jing-yuan',
    name: 'Jing Yuan',
    current_app_rate: 10.5,
    app_eidolons: 6.33,
    app_free: 0.8,
    current_avg_score: 3374,
    round_eidolons: 3469,
    round_free: 3319,
    prev_app_rate: 5.23,
    prev_avg_score: 3326,
    rarity: 'Limited 5*'
  },
  {
    char: 'jingliu',
    name: 'Jingliu',
    current_app_rate: 2.26,
    app_eidolons: 1.52,
    app_free: 0.37,
    current_avg_score: 3327,
    round_eidolons: 3454,
    round_free: 3287,
    prev_app_rate: 0.95,
    prev_avg_score: 3189,
    rarity: 'Limited 5*'
  },
  {
    char: 'kafka',
    name: 'Kafka',
    current_app_rate: 4.9,
    app_eidolons: 3.66,
    app_free: 0.17,
    current_avg_score: 3230,
    round_eidolons: 3360,
    round_free: 3162,
    prev_app_rate: 10.74,
    prev_avg_score: 3295,
    rarity: 'Limited 5*'
  },
  {
    char: 'lingsha',
    name: 'Lingsha',
    current_app_rate: 39.95,
    app_eidolons: 21.37,
    app_free: 8.45,
    current_avg_score: 3487,
    round_eidolons: 3526,
    round_free: 3472,
    prev_app_rate: 41.64,
    prev_avg_score: 3451,
    rarity: 'Limited 5*'
  },
  {
    char: 'luka',
    name: 'Luka',
    current_app_rate: 0.09,
    app_eidolons: 0.03,
    app_free: 0.04,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.01,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'luocha',
    name: 'Luocha',
    current_app_rate: 10.3,
    app_eidolons: 5.29,
    app_free: 2.22,
    current_avg_score: 3410,
    round_eidolons: 3455,
    round_free: 3414,
    prev_app_rate: 9.97,
    prev_avg_score: 3392,
    rarity: 'Limited 5*'
  },
  {
    char: 'lynx',
    name: 'Lynx',
    current_app_rate: 0.3,
    app_eidolons: 0.13,
    app_free: 0.07,
    current_avg_score: 3342,
    round_eidolons: 3468,
    round_free: 3284,
    prev_app_rate: 0.46,
    prev_avg_score: 3304,
    rarity: '4*'
  },
  {
    char: 'march-7th',
    name: 'March 7th',
    current_app_rate: 0.13,
    app_eidolons: 0.1,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 3520,
    round_free: 0,
    prev_app_rate: 0.17,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'march-7th-swordmaster',
    name: 'March 7th - The Hunt',
    current_app_rate: 19.72,
    app_eidolons: 7.37,
    app_free: 7.32,
    current_avg_score: 3473,
    round_eidolons: 3591,
    round_free: 3442,
    prev_app_rate: 9.39,
    prev_avg_score: 3493,
    rarity: '4*'
  },
  {
    char: 'misha',
    name: 'Misha',
    current_app_rate: 0.07,
    app_eidolons: 0.06,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.01,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'moze',
    name: 'Moze',
    current_app_rate: 2.77,
    app_eidolons: 1.11,
    app_free: 0.96,
    current_avg_score: 3338,
    round_eidolons: 3443,
    round_free: 3325,
    prev_app_rate: 0.78,
    prev_avg_score: 3432,
    rarity: '4*'
  },
  {
    char: 'mydei',
    name: 'Mydei',
    current_app_rate: 1.97,
    app_eidolons: 1.33,
    app_free: 0.13,
    current_avg_score: 3377,
    round_eidolons: 3551,
    round_free: 3329,
    prev_app_rate: 1.49,
    prev_avg_score: 3400,
    rarity: 'Limited 5*'
  },
  {
    char: 'natasha',
    name: 'Natasha',
    current_app_rate: 0.07,
    app_eidolons: 0.04,
    app_free: 0.02,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.05,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'pela',
    name: 'Pela',
    current_app_rate: 13.33,
    app_eidolons: 7.24,
    app_free: 0.94,
    current_avg_score: 3363,
    round_eidolons: 3432,
    round_free: 3353,
    prev_app_rate: 11.82,
    prev_avg_score: 3341,
    rarity: '4*'
  },
  {
    char: 'qingque',
    name: 'Qingque',
    current_app_rate: 0.15,
    app_eidolons: 0.13,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 3357,
    round_free: 0,
    prev_app_rate: 0.12,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'rappa',
    name: 'Rappa',
    current_app_rate: 11.21,
    app_eidolons: 4.54,
    app_free: 3.13,
    current_avg_score: 3395,
    round_eidolons: 3479,
    round_free: 3387,
    prev_app_rate: 15.35,
    prev_avg_score: 3432,
    rarity: 'Limited 5*'
  },
  {
    char: 'robin',
    name: 'Robin',
    current_app_rate: 62.39,
    app_eidolons: 32.17,
    app_free: 14.06,
    current_avg_score: 3447,
    round_eidolons: 3560,
    round_free: 3418,
    prev_app_rate: 50.92,
    prev_avg_score: 3447,
    rarity: 'Limited 5*'
  },
  {
    char: 'ruan-mei',
    name: 'Ruan Mei',
    current_app_rate: 39.61,
    app_eidolons: 25.18,
    app_free: 6.28,
    current_avg_score: 3399,
    round_eidolons: 3464,
    round_free: 3371,
    prev_app_rate: 69.53,
    prev_avg_score: 3381,
    rarity: 'Limited 5*'
  },
  {
    char: 'sampo',
    name: 'Sampo',
    current_app_rate: 0.09,
    app_eidolons: 0.04,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.25,
    prev_avg_score: 3222,
    rarity: '4*'
  },
  {
    char: 'seele',
    name: 'Seele',
    current_app_rate: 0.91,
    app_eidolons: 0.76,
    app_free: 0.05,
    current_avg_score: 3548,
    round_eidolons: 3612,
    round_free: 0,
    prev_app_rate: 0.16,
    prev_avg_score: 0,
    rarity: 'Limited 5*'
  },
  {
    char: 'serval',
    name: 'Serval',
    current_app_rate: 14.37,
    app_eidolons: 5.8,
    app_free: 4.46,
    current_avg_score: 3535,
    round_eidolons: 3666,
    round_free: 3518,
    prev_app_rate: 4.54,
    prev_avg_score: 3447,
    rarity: '4*'
  },
  {
    char: 'silver-wolf',
    name: 'Silver Wolf',
    current_app_rate: 2.54,
    app_eidolons: 1.89,
    app_free: 0.07,
    current_avg_score: 3285,
    round_eidolons: 3428,
    round_free: 3270,
    prev_app_rate: 3.38,
    prev_avg_score: 3311,
    rarity: 'Limited 5*'
  },
  {
    char: 'sparkle',
    name: 'Sparkle',
    current_app_rate: 12.16,
    app_eidolons: 10.15,
    app_free: 0.49,
    current_avg_score: 3364,
    round_eidolons: 3470,
    round_free: 3348,
    prev_app_rate: 16.36,
    prev_avg_score: 3299,
    rarity: 'Limited 5*'
  },
  {
    char: 'sunday',
    name: 'Sunday',
    current_app_rate: 41.73,
    app_eidolons: 23.48,
    app_free: 4.73,
    current_avg_score: 3454,
    round_eidolons: 3555,
    round_free: 3426,
    prev_app_rate: 34.59,
    prev_avg_score: 3425,
    rarity: 'Limited 5*'
  },
  {
    char: 'sushang',
    name: 'Sushang',
    current_app_rate: 0.22,
    app_eidolons: 0.12,
    app_free: 0.05,
    current_avg_score: 3436,
    round_eidolons: 3524,
    round_free: 0,
    prev_app_rate: 0.02,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'the-herta',
    name: 'The Herta',
    current_app_rate: 63.94,
    app_eidolons: 26.18,
    app_free: 17.2,
    current_avg_score: 3526,
    round_eidolons: 3626,
    round_free: 3506,
    prev_app_rate: 63.62,
    prev_avg_score: 3489,
    rarity: 'Limited 5*'
  },
  {
    char: 'tingyun',
    name: 'Tingyun',
    current_app_rate: 2.29,
    app_eidolons: 1.31,
    app_free: 0.29,
    current_avg_score: 3339,
    round_eidolons: 3445,
    round_free: 3321,
    prev_app_rate: 3.04,
    prev_avg_score: 3251,
    rarity: '4*'
  },
  {
    char: 'tingyun-fugue',
    name: 'Fugue',
    current_app_rate: 26.4,
    app_eidolons: 16.82,
    app_free: 4.23,
    current_avg_score: 3406,
    round_eidolons: 3479,
    round_free: 3385,
    prev_app_rate: 40.64,
    prev_avg_score: 3409,
    rarity: 'Limited 5*'
  },
  {
    char: 'topaz',
    name: 'Topaz & Numby',
    current_app_rate: 12.01,
    app_eidolons: 6.29,
    app_free: 3.06,
    current_avg_score: 3386,
    round_eidolons: 3524,
    round_free: 3353,
    prev_app_rate: 7.3,
    prev_avg_score: 3480,
    rarity: 'Limited 5*'
  },
  {
    char: 'trailblazer-destruction',
    name: 'Trailblazer - Destruction',
    current_app_rate: 0,
    app_eidolons: 0,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'trailblazer-harmony',
    name: 'Trailblazer - Harmony',
    current_app_rate: 10.34,
    app_eidolons: 6.22,
    app_free: 1.86,
    current_avg_score: 3343,
    round_eidolons: 3417,
    round_free: 3319,
    prev_app_rate: 27.69,
    prev_avg_score: 3344,
    rarity: '4*'
  },
  {
    char: 'trailblazer-preservation',
    name: 'Trailblazer - Preservation',
    current_app_rate: 0.01,
    app_eidolons: 0.01,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.03,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'trailblazer-remembrance',
    name: 'Trailblazer - Remembrance',
    current_app_rate: 39.87,
    app_eidolons: 15.9,
    app_free: 11.39,
    current_avg_score: 3506,
    round_eidolons: 3596,
    round_free: 3490,
    prev_app_rate: 27.19,
    prev_avg_score: 3528,
    rarity: '4*'
  },
  {
    char: 'tribbie',
    name: 'Tribbie',
    current_app_rate: 44.19,
    app_eidolons: 24.73,
    app_free: 8.31,
    current_avg_score: 3547,
    round_eidolons: 3626,
    round_free: 3535,
    prev_app_rate: 44.04,
    prev_avg_score: 3548,
    rarity: 'Limited 5*'
  },
  {
    char: 'welt',
    name: 'Welt',
    current_app_rate: 0.18,
    app_eidolons: 0.09,
    app_free: 0.01,
    current_avg_score: 3241,
    round_eidolons: 3340,
    round_free: 0,
    prev_app_rate: 0.25,
    prev_avg_score: 0,
    rarity: 'Standard 5*'
  },
  {
    char: 'xueyi',
    name: 'Xueyi',
    current_app_rate: 0.02,
    app_eidolons: 0.02,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.04,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'yanqing',
    name: 'Yanqing',
    current_app_rate: 0.16,
    app_eidolons: 0.11,
    app_free: 0.02,
    current_avg_score: 0,
    round_eidolons: 3444,
    round_free: 0,
    prev_app_rate: 0.01,
    prev_avg_score: 0,
    rarity: 'Standard 5*'
  },
  {
    char: 'yukong',
    name: 'Yukong',
    current_app_rate: 0,
    app_eidolons: 0,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.03,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'yunli',
    name: 'Yunli',
    current_app_rate: 3.82,
    app_eidolons: 2.35,
    app_free: 0.44,
    current_avg_score: 3287,
    round_eidolons: 3399,
    round_free: 3259,
    prev_app_rate: 4.35,
    prev_avg_score: 3303,
    rarity: 'Limited 5*'
  }
];
